import { render, staticRenderFns } from "./SectionAncestorsCreate.vue?vue&type=template&id=3acffb46&scoped=true&"
import script from "./SectionAncestorsCreate.vue?vue&type=script&lang=js&"
export * from "./SectionAncestorsCreate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3acffb46",
  null
  
)

export default component.exports